// src/component/admin/future-gifts/ScheduledGiftsTab.jsx
import React, { useState } from 'react';
import { AlertTriangleIcon, ClockIcon, ProductCatalogIcon, ArrowDown, SearchIcon } from '../../../public/icons';
import Pagination from '../../shared/Pagination';

const ScheduledGiftsTab = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filter, setFilter] = useState('all');

  const statusStats = [
    { 
      label: '1 gift at risk', 
      bordercolor: '#FFC7C9', 
      bgcolor: '#FFF3F3', 
      Bigtextcolor: '#8E0012', 
      smalltextcolor: '#D30000',
      count: 1 
    },
    { 
      label: '4 Awaiting Content', 
      bordercolor: '#FFF074', 
      bgcolor: '#FEFCE6', 
      Bigtextcolor: '#7B3A00', 
      smalltextcolor: '#B25B00',
      count: 4 
    },
    { 
      label: '1 ready for production', 
      bordercolor: '#A6FACC', 
      bgcolor: '#EEFDF3', 
      Bigtextcolor: '#005627', 
      smalltextcolor: '#00842A',
      count: 1 
    }
  ];

  const filters = [
    { id: 'all', label: 'All Gift' },
    { id: 'at-risk', label: 'At Risk' },
    { id: 'awaiting', label: 'Awaiting Content' },
    { id: 'ready', label: 'Ready' },
    { id: 'in-production', label: 'In Production' },
    { id: 'delivered', label: 'Delivered' }
  ];

  const scheduledGifts = [
    { 
      id: 1,
      customer: 'Esther James', 
      giftType: 'Memory Magnet Set', 
      sequence: '2 of 3', 
      revealDate: 'Jan 31, 2026', 
      daysLeft: '0 days left',
      contentStatus: 'Submitted', 
      fulfillmentStatus: 'Delivered'
    },
    { 
      id: 2,
      customer: 'Adebayo Johnson', 
      giftType: 'Memory Magnet Set', 
      sequence: '3 of 3', 
      revealDate: 'Feb 14, 2026', 
      daysLeft: '9 days left',
      contentStatus: 'Submitted', 
      fulfillmentStatus: 'Ready'
    },
    { 
      id: 3,
      customer: 'Chiamaka Chukwuka', 
      giftType: 'Audio Gift', 
      sequence: '1 of 3', 
      revealDate: 'Mar 05, 2026', 
      daysLeft: '11 days left',
      contentStatus: 'In progress', 
      fulfillmentStatus: 'Waiting'
    },
    { 
      id: 4,
      customer: 'Ngozi Adewale', 
      giftType: 'Memory Magnet Set', 
      sequence: '3 of 3', 
      revealDate: 'Feb 10, 2026', 
      daysLeft: '5 days left',
      contentStatus: 'Submitted', 
      fulfillmentStatus: 'In production'
    },
    { 
      id: 5,
      customer: 'Emeka Nwachukwu', 
      giftType: 'Digital Memory', 
      sequence: '0 of 3', 
      revealDate: 'Apr 10, 2026', 
      daysLeft: '1 day left',
      contentStatus: 'Not started', 
      fulfillmentStatus: 'Waiting'
    }
  ];

  const getContentStatusBadge = (status) => {
    const statusConfig = {
      'Submitted': {
        textColor: 'text-[#2F8F5B]',
        bgColor: 'bg-[#E7F4ED]',
        dotColor: 'bg-[#2F8F5B]'
      },
      'In progress': {
        textColor: 'text-[#194F9B]',
        bgColor: 'bg-[#EBEFFF]',
        dotColor: 'bg-[#194F9B]'
      },
      'Not started': {
        textColor: 'text-[#D8A100]',
        bgColor: 'bg-[#FFF4D6]',
        dotColor: 'bg-[#D8A100]'
      },
      'Default': {
        textColor: 'text-[#6B635D]',
        bgColor: 'bg-gray-100',
        dotColor: 'bg-gray-400'
      }
    };

    const config = statusConfig[status] || statusConfig.Default;

    return (
      <span className={`flex items-center gap-1.5 px-3 py-1.5 text-xs leading-5 font-semibold rounded-full ${config.bgColor} w-fit`}>
        <span className={`h-2 w-2 rounded-full ${config.dotColor}`} />
        <span className={config.textColor}>
          {status}
        </span>
        <ArrowDown size={12} className={config.textColor} />
      </span>
    );
  };

  const getFulfillmentStatusBadge = (status) => {
    const statusConfig = {
      'Delivered': {
        textColor: 'text-[#2F8F5B]',
        bgColor: 'bg-[#E7F4ED]',
        dotColor: 'bg-[#2F8F5B]'
      },
      'Ready': {
        textColor: 'text-[#194F9B]',
        bgColor: 'bg-[#EBEFFF]',
        dotColor: 'bg-[#194F9B]'
      },
      'In production': {
        textColor: 'text-[#D8A100]',
        bgColor: 'bg-[#FFF4D6]',
        dotColor: 'bg-[#D8A100]'
      },
      'Waiting': {
        textColor: 'text-[#8F342F]',
        bgColor: 'bg-[#F4E7E7]',
        dotColor: 'bg-[#8F342F]'
      },
      'Default': {
        textColor: 'text-[#6B635D]',
        bgColor: 'bg-gray-100',
        dotColor: 'bg-gray-400'
      }
    };

    const config = statusConfig[status] || statusConfig.Default;

    return (
      <span className={`flex items-center gap-1.5 px-3 py-1.5 text-xs leading-5 font-semibold rounded-full ${config.bgColor} w-fit`}>
        <span className={`h-2 w-2 rounded-full ${config.dotColor}`} />
        <span className={config.textColor}>
          {status}
        </span>
        <ArrowDown size={12} className={config.textColor} />
      </span>
    );
  };

  const handleViewAction = (id) => {
    console.log('View scheduled gift:', id);
    // Handle view action here
  };

  // Filter gifts based on search
  const filteredGifts = scheduledGifts.filter(gift => {
    const matchesSearch = gift.customer.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         gift.giftType.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilter = filter === 'all' || 
                         gift.fulfillmentStatus.toLowerCase().includes(filter.toLowerCase());
    return matchesSearch && matchesFilter;
  });

  return (
    <div className="p-6">
      {/* Status Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
        {statusStats.map((stat, index) => (
          <div 
            key={index} 
            className="rounded-sm p-5" 
            style={{ 
              border: `2px solid ${stat.bordercolor}`,
              backgroundColor: stat.bgcolor 
            }}
          >
            <div className="text-left">
              <div>
                <p className="text-base font-medium mt-1" style={{ color: stat.Bigtextcolor }}>
                  {stat.label}
                </p>
                <p className="text-sm font-normal mt-1" style={{ color: stat.smalltextcolor }}>
                  {index === 0 ? 'Require immediate attention' : 
                   index === 1 ? 'Customers need to upload' : 
                   'All content received'}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className='bg-white'>
        {/* Scheduled Gift Management - Header */}
        <div className="mb-6 p-3">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-medium text-[#0E1628]">Scheduled Gift Management</h2>
            
            <div className="flex gap-4 items-center">
              {/* Search Box */}
              <div className="relative">
                <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                  <SearchIcon size={20} className="text-[#6B635D]" />
                </div>
                <input
                  type="text"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="p-2 pl-10 pr-3 border w-52 border-[#DBDBDB] bg-transparent placeholder:text-[#6B635D] placeholder:text-sm focus:outline-none focus:ring-1 focus:ring-[#D4A574] focus:border-transparent"
                />
              </div>

              {/* Filter Dropdown - Updated */}
              <div className="relative">
                <select
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                  className="p-2 pl-3 pr-8 border w-40 border-[#DBDBDB] bg-transparent text-[#1C2A46] text-sm appearance-none focus:outline-none focus:ring-1 focus:ring-[#D4A574] focus:border-transparent"
                >
                  {filters.map(filterItem => (
                    <option key={filterItem.id} value={filterItem.id}>
                      {filterItem.label}
                    </option>
                  ))}
                </select>
                <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
                  <ArrowDown size={16} className="text-[#6B635D]" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table with white background */}
        <div className="bg-white overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-[#DBDBDB]">
              <thead className="bg-[#F3F4F6]">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
                    Customer
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
                    Gift Type
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
                    Sequence
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
                    Reveal Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider w-fit">
                    Content Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider w-fit">
                    Fulfilment Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider w-20">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-[#DBDBDB] text-left">
                {filteredGifts.map((gift) => (
                  <tr key={gift.id} className="hover:bg-gray-50 transition-colors duration-150">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-normal text-[#0E1628]">{gift.customer}</div>
                      <div className="text-xs font-normal text-[#8A9099]">{gift.daysLeft}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm font-normal text-[#0E1628]">{gift.giftType}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="inline-flex items-center justify-center w-8 h-8 bg-gray-100 text-[#0E1628] rounded-full text-sm font-normal">
                        {gift.sequence.split(' ')[0]}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-normal text-[#0E1628]">{gift.revealDate}</div>
                      <div className="text-xs font-normal text-[#8A9099]">{gift.daysLeft}</div>
                    </td>
                    <td className="px-6 font-normal py-4 whitespace-nowrap w-fit">
                      {getContentStatusBadge(gift.contentStatus)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap w-fit">
                      {getFulfillmentStatusBadge(gift.fulfillmentStatus)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap w-20">
                      <button
                        onClick={() => handleViewAction(gift.id)}
                        className="text-[#6B635D] hover:text-[#1C2A46] transition-colors mx-auto block flex items-center gap-1"
                      >
                        <span className="text-sm">View</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <Pagination totalItems={filteredGifts.length} itemsPerPage={5} />
        </div>
      </div>
    </div>
  );
};

export default ScheduledGiftsTab;